/**
 * PlaceholderPage — used by every nav target that hasn't been built yet.
 *
 * Keeps the sidebar working and the URLs valid so we can demo navigation
 * before each module is migrated. Replace by importing a real page component
 * in `router.tsx`.
 */
import { Construction } from "lucide-react";
import { Card, CardContent, CardTitle, CardSub } from "@/components/ui/card";

export interface PlaceholderPageProps {
  title: string;
  hint?: string;
}

export function PlaceholderPage({ title, hint }: PlaceholderPageProps) {
  return (
    <div className="flex flex-col gap-6">
      <h1 className="m-0 text-3xl font-extrabold tracking-tight text-aurora">{title}</h1>
      <Card>
        <CardContent className="flex items-center gap-4">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-aurora-soft text-violet">
            <Construction size={20} />
          </div>
          <div>
            <CardTitle>Migration in progress</CardTitle>
            <CardSub>{hint ?? "This module is being ported to the new React frontend."}</CardSub>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
